import React from "react";

// Shared layout for the Cookie Policy and Do Not Sell or Share pages (same structure as the
// forzabuilt-website legal pages, in RuggedRed colors).

export const legalLinkClass = "text-[#D3242A] hover:underline font-semibold";

export const LegalPage = ({ title, effectiveDate, children }) => (
  <div className="bg-white min-h-screen">
    <section className="relative py-8 md:py-12 lg:py-16 px-4 bg-white">
      <div className="max-w-4xl mx-auto space-y-8 md:space-y-12">
        <div className="text-center mb-8 md:mb-12">
          <h1 className="leading-tight text-[#1A1A1A] mb-3 md:mb-4 text-center break-words text-[28px] md:text-[48px]">
            {title}
          </h1>
          <p className="text-sm md:text-base text-[#1A1A1A]/70">Effective Date: {effectiveDate}</p>
          <div className="w-32 md:w-40 h-0.5 md:h-1 bg-[#D3242A] mx-auto mt-4 md:mt-6"></div>
        </div>
        {children}
      </div>
    </section>
  </div>
);

export const LegalIntro = ({ children }) => (
  <div className="space-y-4 text-base md:text-lg lg:text-xl text-[#1A1A1A]/80 leading-relaxed">
    {children}
  </div>
);

export const LegalSection = ({ title, children }) => (
  <div className="space-y-4 md:space-y-6">
    <h2
      className="leading-none text-[#1A1A1A] font-bold"
      style={{ fontSize: "clamp(20px, 2vw + 0.5rem, 40px)" }}
    >
      {title}
    </h2>
    <div className="w-32 md:w-40 h-0.5 md:h-1 bg-[#D3242A]"></div>
    <div className="space-y-4 text-base md:text-lg lg:text-xl text-[#1A1A1A]/80 leading-relaxed">
      {children}
    </div>
  </div>
);
